import { render, staticRenderFns } from "./step-required-question.vue?vue&type=template&id=28f7ce9a&"
import script from "./step-required-question.vue?vue&type=script&lang=js&"
export * from "./step-required-question.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports